import { makeStyles, createStyles } from '@material-ui/core/styles';
import { COLORS } from './../../config/theme/baseTheme';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      alignSelf: "center",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      backgroundColor: COLORS.LOADER_BACKGROUND,
      height: "100vh", // Full viewport height
      width: "100%",   // Full viewport width
    }
  })
)